export const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const SQUARE_APP_ID = process.env.REACT_APP_SQUARE_APP_ID;
export const SQUARE_LOCATION_ID = process.env.REACT_APP_SQUARE_LOCATION_ID;
export const SQUARE_URL = process.env.REACT_APP_SQUARE_URL;
export const META_FACEBOOK_NAME = process.env.REACT_APP_META_FACEBOOK_NAME;
export const ZOOM_API_URL = process.env.REACT_APP_ZOOM_API_URL;
export const FILE_UPLOAD_URL = process.env.REACT_APP_FILE_UPLOAD_URL;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_DATABASE_URL =
  process.env.REACT_APP_FIREBASE_DATABASE_URL;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID =
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
